import React from 'react'
import Layout from '../../components/Layout'
import '../index.css'
import { Link } from 'gatsby'

import diplomats_Advocate_INFJ_personality_header from '../../images/personality_types_details/diplomats_Advocate_INFJ_personality_header.svg'
import diplomats_Advocate_INFJ_workplace_habits from '../../images/personality_types_details/diplomats_Advocate_INFJ_workplace_habits.svg'
import circleforward from '../../images/personality_types_details/circleforward.png'
import circleback from '../../images/personality_types_details/circleback.png'

const infjs_at_work = () => {
    return (
        <Layout>
            <main className="q-td analyst advocate">
                {/* --------------------mobile child nav bar------------------------ */}
                <nav className="top-tabs mobile-only" aria-label="Personality description">

                    <Link to='/personality-types/advocate-infj-personality' className="tab with-progress">
                        <span className="title">Introduction</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/advocate-infj-strengths-and-weaknesses" className="tab with-progress">
                        <span className="title">Strengths and Weaknesses</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/advocate-infj-relationships-dating" className="tab with-progress ">
                        <span className="title">Romantic Relationships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab with-progress">
                        <span className="title">Friendships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/advocate-infj-parents" className="tab with-progress ">
                        <span className="title">Parenthood</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/advocate-infj-careers" className="tab with-progress">
                        <span className="title">Career Paths</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/advocate-infjs-at-work" className="tab with-progress active">
                        <span className="title">Workplace Habits</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/advocate-infj-conclusion" className="tab with-progress ">
                        <span className="title">Conclusion</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab premium">
                        <span className="title">Premium Profile</span>
                    </Link>

                </nav>
                {/* -------------------- picture and title-------------------------- */}
                <header class="type-header diplomat advocate">

                    <svg class="background" viewBox="0 0 1920 600" preserveAspectRatio="none">
                        <path class="st0" d="M400 598.9l1520-152.8v164.4H0v-288z"></path>
                        <path class="st1" d="M923.4 546.3l996.6-97.4V1.5h-851z"></path>
                    </svg>

                    <img src={diplomats_Advocate_INFJ_personality_header} class="scene" alt='loading...' />
                    <div class="type-info">
                        <h1><span>Advocate</span> Personality</h1>
                        <div class="code">INFJ-A / INFJ-T</div>
                        <a href="#" class="difference">(What’s the difference?)</a>
                    </div>

                </header>



                {/* -------------------------side bar section------------------------------------- */}
                <div className="with-sidebars">

                    <div className="sidebar left">
                        <nav className="sections" id="sticky-sidebar" style={{ paddingTop: '50px' }}>
                            <div className="title">Explore This Type</div>
                            <ul>
                                <li className=""><Link to='/personality-types/advocate-infj-personality'>Introduction</Link></li>
                                <li className=""><Link to="/personality-types/advocate-infj-strengths-and-weaknesses">Strengths & Weaknesses</Link></li>
                                <li className=""><Link to="/personality-types/advocate-infj-relationships-dating">Romantic Relationships</Link></li>
                                <li className=""><Link to="/personality-types/advocate-infj-friends">Friendships</Link></li>
                                <li className=""><Link to="/personality-types/advocate-infj-parents">Parenthood</Link></li>
                                <li className=""><Link to="/personality-types/advocate-infj-careers">Career Paths</Link></li>
                                <li className="active"><Link to="/personality-types/advocate-infjs-at-work">Workplace Habits</Link></li>
                                <li className=""><Link to="/personality-types/advocate-infj-conclusion">Conclusion</Link></li>
                                <li className="premium"><Link to="/">Premium Profile</Link></li>
                            </ul>
                        </nav>
                        <daily-insight v-cloak personality-type="INTJ"></daily-insight>
                    </div>
                    {/* ----------------------------description pages of sidebar------------------------------------- */}
                    <article class="main description">

                        <h1>Workplace Habits</h1>


                        <p>Advocates (INFJs) have some specific needs when it comes to a satisfying work environment. People with this personality type want to know that their work helps people and promotes their own personal growth. This means that their work must be in line with their values, principles, and beliefs.</p>

                        <p>In the workplace, Advocates tend to thrive when they have opportunities to express their creativity and insight, and they’re especially motivated when they know that what they’re doing has meaning. They also tend to do best when they can ignore workplace politics and hierarchies and simply do what matters to them. Most people with this personality type prefer not to think of themselves as above or below anyone else – no matter where they are on the job ladder.</p>

                        <p>Fortunately, Advocates are resourceful and creative, and they can find ways to make nearly any position work for them.</p>

                        <div class="scene"><img alt="Advocate (INFJ) workplace habits" src={diplomats_Advocate_INFJ_workplace_habits} /></div>

                        <h2>Advocate Subordinates</h2>

                        <p>Advocates value cooperation, sensitivity, and independence. As employees, they tend to gravitate toward managers who are open-minded and willing to consider their input. Advocate personalities may become frustrated when they feel unheard, so having a manager who listens to them can make all the difference.</p>

                        <p>Ideally, Advocates will also find a manager whose values align with their own and who offers them encouragement and praise. Because Advocates tend to act on their convictions and aim to do their best, their morale can be vulnerable to criticism, particularly if it’s unwarranted. Other morale killers for these personalities may include strict rules, formal structures, and routine tasks.</p>

                        <p>Of course, a perfect work environment isn’t always possible. Advocate employees with less-than-ideal managers may need to draw on their inner resilience and seek out other mentors. The good news is that people with this personality type are more than capable of handling workplace challenges, including the challenge of having a difficult manager.</p>

                        <h2>Advocate Colleagues</h2>

                        <p>As colleagues, Advocates can be quite popular and well-respected. People with this personality type are likely to be seen as positive, eloquent, and capable coworkers. Among their greatest strengths is their ability to identify others’ motives and defuse conflicts and tension before anyone else even senses a disturbance.</p>

                        <p>At times, efficiency may be less of a priority for Advocates than collaborating with and helping colleagues who need a boost. While this is usually a strength, there is a risk that others will take advantage of their desire to help. Advocates may find themselves picking up the slack for their less dedicated coworkers at the expense of their own energy and well-being.</p>

                        <p>Although they tend to be warm and approachable colleagues, Advocates are still Introverts. From time to time, they may need to step back and work alone, pursuing their own goals in their own ways.</p>

                        <h2>Advocate Managers</h2>

                        <p>As managers, Advocates may dislike wielding their power. These personalities prefer to see those who work under them as equals. Rather than micromanage their subordinates, Advocates often prefer to empower them to think and act independently. They work hard to encourage others, not to crack the whip.</p>

                        <p>That’s not to say that Advocates have low standards – far from it. Their sense of equality means that they expect their subordinates to live up to the standards that they set for themselves. Advocate personalities want their employees to be rigorous, motivated, reliable, and unfailingly honest, and they will notice if their employees miss the mark.</p>

                        <p>Compassionate and fair, Advocate managers often take pride in identifying their subordinates’ unique strengths. They make an effort to understand their employees’ motivations – an effort that is helped by Advocates’ Intuitive insights.</p>

                        <p>That said, people with this personality type can be quite stern if they catch someone behaving in a way that they consider unethical. Advocates have little tolerance for lapses in reliability or morality. When their employees’ good intentions match their own, however, Advocates will work tirelessly to ensure that their entire team feels valued and fulfilled.</p>

                        <div class="number">07</div>


                    </article>
                </div>

                <div className="navigation-buttons comp" data-chunk="type-chunk">
                    <div className="part left">
                        <Link to='/personality-types/advocate-infj-careers' className='next-feature'>
                            Career Paths
                       <br /><br />
                            <img src={circleback} width={75} height={75} />
                        </Link>
                    </div>
                    <div className="part right">
                        <Link to='/personality-types/advocate-infj-conclusion' className='next-feature'>
                            Conclusion
                       <br /><br />
                            <img src={circleforward} width={75} height={75} />
                        </Link>
                    </div>
                </div>

            </main>
        </Layout>
    )
}

export default infjs_at_work
